import { AggregateDataReporter } from '../AggregateDataReporter';
export function buildNewRelicAggregateReporter(Reporter = AggregateDataReporter) {
  return new Reporter(data => {
    // @ts-expect-error custom window types aren't available in all builds
    if (window.newrelic && window.newrelic.addPageAction) {
      // @ts-expect-error custom window types aren't available in all builds
      window.newrelic.addPageAction('realtime-stats', data);
    }
  });
}